import COLORS from '@/constants/colors';
import { useGlobalContext } from '@/context/Global/GlobalContext';
import { DashboardUserType } from '@/utils/enums';
import LogoutIcon from '@mui/icons-material/Logout';
import { ListItemButton, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import posthog from 'posthog-js';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HelperButton } from './HelperButton';

export function BottomMenu() {
  const [onlyIconsMenu] = useState(false);
  const navigate = useNavigate();

  const { session, clearSession } = useGlobalContext();

  const handleLogout = () => {
    clearSession();
    posthog.reset();
    switch (session?.type) {
      case DashboardUserType.ADMIN:
        navigate('/login/admin');
        break;
      case DashboardUserType.SELLER:
      default:
        navigate('/login');
        break;
    }
  };

  const userTypeDisplay =
    session?.type === DashboardUserType.ADMIN
      ? 'Administrador'
      : (session?.businessName ?? '');

  return (
    <Box>
      {session?.type === DashboardUserType.SELLER && <HelperButton />}
      <ListItemButton
        onClick={handleLogout}
        sx={{
          marginBottom: '0px',
          paddingBottom: '0px',
          px: '12px',
        }}
      >
        <Box
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            width: '206px',
            display: 'flex',
            padding: '8px',
            textDecoration: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          <LogoutIcon />
          {!onlyIconsMenu && (
            <Typography
              sx={{
                margin: '0px 12px',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '20px',
                color: COLORS.gray_3,
              }}
            >
              Cerrar sesión
            </Typography>
          )}
        </Box>
      </ListItemButton>
      <Box
        sx={{
          padding: '16px 10px',
          display: 'flex',
          alignItems: 'center',
          borderTop: `1px solid ${COLORS.gray_200}`,
          cursor: 'initial',
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: COLORS.gray_200,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              color: COLORS.gray_3,
              fontSize: '14px',
            }}
          >
            {session?.name ? session.name.charAt(0).toUpperCase() : ''}
          </Typography>
        </Box>
        {!onlyIconsMenu && (
          <Box sx={{ mx: '8px' }}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 600,
                color: COLORS.blackish,
                fontSize: '12px',
                lineHeight: '24px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '22ch',
              }}
            >
              {userTypeDisplay}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                color: COLORS.blackish,
                fontSize: '11px',
                lineHeight: '24px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '22ch',
              }}
            >
              {session?.name ?? ''}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
